import { createSlice } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";

export type BottomDrawerInitialStateTypes = {
  bottomDrawerStatus: boolean;
};

const initialState: BottomDrawerInitialStateTypes = {
  bottomDrawerStatus: false,
};

const bottomDrawerSlice = createSlice({
  name: "bottomDrawer",
  initialState,
  reducers: {
    openBottomDrawer: (state) => {
      state.bottomDrawerStatus = true;
    },
    closeBottomDrawer: (state) => {
      state.bottomDrawerStatus = false;
    },
    toggleBottomDrawer: (state) => {
      state.bottomDrawerStatus = !state.bottomDrawerStatus;
    },
  },
});

export const { openBottomDrawer, closeBottomDrawer, toggleBottomDrawer } = bottomDrawerSlice.actions;

export const useBottomDrawer = () => {
  const dispatch = useAppDispatch();
  const { bottomDrawerStatus } = useAppSelector((state) => state.bottomDrawer);

  return {
    bottomDrawerStatus,
    openBottomDrawer: () => dispatch(openBottomDrawer()),
    closeBottomDrawer: () => dispatch(closeBottomDrawer()),
    toggleBottomDrawer: () => dispatch(toggleBottomDrawer()),
  };
};

export default bottomDrawerSlice.reducer;